<app-alert></app-alert>

<div class="modal-dialog" role="document" style="max-width: 100%;margin: 0px auto">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="myModalLabelForDeletion">
        <i></i>Allottee</h5>
      <button aria-label="Close" class="close" (click)="closeModal()" data-dismiss="modal" type="button">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <form [formGroup]="alloteesForm" class="well">
      <div class="modal-body card">

        <div *ngIf="allotteeStatus == 'createNew'" class="row" style="margin-top: 10px;">
          <div class="col-md-2">
            <label class="form-control-label"><b>Investor code selection</b>
            </label>
          </div>
          <div class="col-md-10 form-group">
            <div class="row">
              <div class="col-md-5">
                <input type="radio" id="existingAllottees" name="investorCodeSelection" value="existing"
                  formControlName="investorCodeSelection" checked="true" (click)="changeInvestorCodeSelection()">
                <label for="existingAllottees">Existing allottees available from master</label>
              </div>
              <div class="col-md-7">
                <input type="radio" id="newallottees" name="investorCodeSelection" value="new"
                  formControlName="investorCodeSelection" (click)="clearAllDataForNewAllottee()">
                <label for="newallottees">New</label>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->

        <div class="row ">
          <div class="col-md-2">
            <label class="form-control-label">Sr No</label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="srno" (keydown)="onlyNumber($event)" class="form-control" formControlName="srNo" type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Investor Code <span style="color: red;">*</span>
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div *ngIf="allotteeStatus == 'createNew'">
            <div *ngIf="alloteesForm.controls.investorCodeSelection.value == 'new'" class="input-group">
              <input id="investorCode" formControlName="investorCode" class="form-control"
                (keyup)="onBlurCheckInvestorCode()" (keydown)="noBlankSpaceAtStart($event)" required="required">
            </div>
            <div *ngIf="alloteesForm.controls.investorCodeSelection.value == 'existing'" class="input-group">
              <select class="form-control" id="investorCode2" formControlName="investorCode" style="padding:6px;"
                (change)="fetchAllotteeDetailsByInvestorCode($event)">
                <option value='' [selected]="true">Select Code</option>
                <option *ngFor="let existingAllotteesInvestorCode of existingAllotteesInvestorCodeList; let i = index;"
                  [value]=existingAllotteesInvestorCode.investorCode>{{existingAllotteesInvestorCode.investorCode}}
                  <input type="hidden" id="hiddenAlloteeId{{i}}" value="{{existingAllotteesInvestorCode._id}}">
                </option>
              </select>
            </div>
            <span *ngIf="alloteesForm.get('investorCode').errors && (alloteesForm.get('investorCode').touched || alloteesForm.get('investorCode').dirty)">
              <span *ngIf="alloteesForm.get('investorCode').errors.required" class="error">investor Code is required</span>
            </span>
            <span *ngIf="isInvestorCodeUnique" class="error">
              Investor Code already exists
            </span>
          </div>
          <div *ngIf="allotteeStatus == 'update'">
            <div class="input-group">
              <input id="investorCode" formControlName="investorCode" class="form-control"
                (keyup)="onBlurCheckInvestorCode()" (keydown)="noBlankSpaceAtStart($event)" readonly required="required">
            </div>
          </div>
        </div>

          <div class="col-md-2">
            <label class="form-control-label">Name <span style="color: red;">*</span>
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-group">
                <input id="name" class="form-control" formControlName="name" type="text" (keydown)="noBlankSpaceAtStart($event)" required="required">
              </div>
              <span *ngIf="alloteesForm.get('name').errors && (alloteesForm.get('name').touched || alloteesForm.get('name').dirty)">
                <span *ngIf="alloteesForm.get('name').errors.required" class="error">Name is required</span>
                <!-- <span *ngIf="alloteesForm.get('name').errors.pattern">Please enter valid name Address</span> -->
              </span>
            </div>

          </div>

          <div class="col-md-2">
            <label class="form-control-label">Address Line 1
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="line1" formControlName="addressLine1" class="form-control">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Line 2
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="line2" formControlName="addressLine2" class="form-control">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Line 3
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="line3" formControlName="addressLine3" class="form-control">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">City
            </label>
          </div>
          <div class="col-md-4 form-group">
            <input formControlName="city" class="form-control" (keydown)="onlyAlphabates($event)">
            <!-- <div *ngIf="alloteesForm.controls['city'].hasError('pattern') && alloteesForm.controls['city'].touched"
              class="form-control-error-custom">
              City is invalid.
            </div> -->
          </div>

          <div class="col-md-2">
            <label class="form-control-label">State
            </label>
          </div>
          <div class="col-md-4 form-group">
            <input formControlName="state" class="form-control" (keydown)="onlyAlphabates($event)">
            <!-- <div *ngIf="alloteesForm.controls['state'].hasError('pattern') && alloteesForm.controls['state'].touched"
              class="form-control-error-custom">
              State is invalid.
            </div> -->
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Country
            </label>
          </div>
          <div class="col-md-4 form-group">
            <input formControlName="country" class="form-control" (keydown)="onlyAlphabates($event)">
            <!-- <div *ngIf="alloteesForm.controls['country'].hasError('pattern') && alloteesForm.controls['country'].touched"
              class="form-control-error-custom">
              Country is invalid.
            </div> -->
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Pin Code
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="pincode" (keydown)="onlyNumber($event)" class="form-control" formControlName="pinCode"
                type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Email
            </label>
          </div>
          <div class="col-md-4 form-group">
            <input id="email" formControlName="email" class="form-control email" type="text">
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Mobile
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-group">
                <input id="mobile" (keydown)="onlyNumber($event)" class="form-control" formControlName="mobile"
                  pattern="^\d{10}$" type="text">
              </div>
              <span
                *ngIf="alloteesForm.controls['mobile'].hasError('pattern') && alloteesForm.controls['mobile'].touched"
                class="form-control-error-custom" class="error">
                Mobile Number is not valid.
              </span>
            </div>
          </div>

          <!-- <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="mobile" (keydown)="onlyNumber($event)" class="form-control" formControlName="mobile"
                pattern="^\d{10}$" type="text">
              <span
                *ngIf="alloteesForm.controls['mobile'].hasError('pattern') && alloteesForm.controls['mobile'].touched"
                class="form-control-error-custom">
                Mobile Number is not valid.
              </span>
            </div>
          </div> -->

          <div class="col-md-2">
            <label class="form-control-label">PAN
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-group">
              <input id="pan" class="form-control upperCase" pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$"
                title="Please enter valid PAN. E.g. AAAAA9999A" formControlName="PAN" type="text">
            </div>
            <span *ngIf="alloteesForm.controls['PAN'].hasError('pattern') && alloteesForm.controls['PAN'].touched"
              class="form-control-error-custom" class="error">
              PAN is not valid.
            </span>
          </div>
        </div>

          <div class="col-md-2">
            <label class="form-control-label">Investor Category
            </label>
          </div>

          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="investorCategory" class="form-control" formControlName="investorCategory" type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Investor Subcategory
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input id="investorSubCategory" class="form-control" formControlName="investorSubCategory" type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Bank Name
            </label>
          </div>

          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="bankname" class="form-control" formControlName="bankName" type="text">
            </div>
          </div>


          <div class="col-md-2">
            <label class="form-control-label">IFSC
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!-- <input id="ifsc" class="form-control" formControlName="IFSC" type="text"> -->

              <div class="input-group">
                <input id="ifsc" class="form-control upperCase" pattern="[A-Z|a-z]{4}[0][\d]{6}$"
                  title="Please enter valid IFSC number. E.g. CITI0344444" formControlName="IFSC" type="text">
              </div>
              <span *ngIf="alloteesForm.controls['IFSC'].hasError('pattern') && alloteesForm.controls['IFSC'].touched"
                class="form-control-error-custom" class="error">
                IFSC code is not valid.
              </span> 
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Virtual Account No
            </label>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input id="virtualAccNo" class="form-control" formControlName="virtualAccountNo" type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">DP Type
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <select class="form-control" id="dptype" formControlName="dpType" style="padding:6px;">
                <option value=''>Select</option>
                <option *ngFor="let dpType of dpTypeList" value="{{dpType}}">{{dpType}}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">DP Id
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="dpId" class="form-control" maxlength="8" formControlName="dpID" type="text">
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-control-label">Ben/Cli Id
            </label>
          </div>
          <div class="col-md-4 form-group">
            <div class="input-group">
              <input id="benCliId" (keydown)="onlyNumber($event)" class="form-control" formControlName="benCliId"
                type="text" maxlength="8">
            </div>
          </div>

        </div>

        <div class="row modal-header col-md-12" style="max-height: 50px;">
          <h6 style="text-align: center"><b>Multi-Options Based</b> </h6>
        </div>

        <div formArrayName="allotteesDynamicFieldsArray"
          *ngFor="let MultiOption of issueDetails.MultiOption; let i = index;" style="margin-bottom: -14px;">
          <div [formGroupName]="i">
            <div class="col-md-12 clearfix panel-group panel panel-primary panel-highlighted">
              <h5><b><label> Option {{i + 1}} :</label></b></h5>
              <div class="row" style="margin-top: 5px;">

                <div class="col-md-2">
                  <label class="form-control-label">Payin Amount
                  </label>
                </div>
                <div class="col-md-4 form-group">
                  <div class="input-group">
                    <input id="payinAmount{{i}}" (keydown)="onlyNumber($event)" class="form-control"
                      formControlName="payinAmount" type="text">
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">Payout Quantity
                  </label>
                </div>
                <div class="col-md-4 form-group">
                  <div class="input-group">
                    <input id="payoutQuantity{{i}}" (keydown)="onlyNumber($event)" class="form-control"
                      formControlName="payoutQuantity" type="text">
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <button *ngIf="!btnadd" id="update" type="button" class="btn-sm btn btn-primary"
            [disabled]="!alloteesForm.valid || isInvestorCodeUnique || disabledOnclick" (click)="allotteeFormObjectForsaveAndUpdate()">
            <i class="fa fa-save"></i>&nbsp;Update</button>
          <button *ngIf="btnadd" id="add" type="submit" class="btn-sm btn btn-primary"
            [disabled]="!alloteesForm.valid || isInvestorCodeUnique || disabledOnclick" (click)="allotteeFormObjectForsaveAndUpdate()">
            <i class="fa fa-save"></i>&nbsp;Save</button>
          <button type="button" class="btn-sm btn btn-default" (click)="closeModal()" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>
        </div>
      </div>
    </form>

  </div>
</div>